import { isBenched } from '../../lib/field-time-live';

// Shared by the planner's "At a glance" pane and the live game's side pane.

/**
 * One player's innings in order: filled for the field, an empty box for the
 * bench, an empty box with a dot for extra hitter (bats, doesn't field).
 */
export const InningStrip = ({ positions }: { positions: string[] }) => (
  <span className="flex items-center gap-[2px]" aria-hidden="true">
    {positions.map((pos, i) => (
      <span
        key={i}
        title={`Inning ${i + 1}: ${pos === 'BENCH' ? 'Bench' : pos === 'EH' ? 'Extra hitter' : pos}`}
        className={`w-[14px] h-[14px] rounded-[4px] flex items-center justify-center ${
          isBenched(pos) ? 'border-[1.5px] border-ink-mute' : 'bg-accent'
        }`}
      >
        {pos === 'EH' && <span className="w-[4px] h-[4px] rounded-full bg-ink-2" />}
      </span>
    ))}
  </span>
);
